import { genericReport } from "@dataseat-dsp-client/lib-reporter";

//reexport enum
export { TimeRange } from "@dataseat-dsp-client/lib-reporter";

export const TimeRangeLabelsDict = genericReport.TimeRangeLabelsDict;
